import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import countries from 'i18n-iso-countries';

import {
  Grid,
  Segment,
  Modal,
  Button,
  Icon,
  Dropdown,
  Search,
} from 'semantic-ui-react';

import {
  AvForm,
  AvField,
  AvRadio,
  AvRadioGroup,
} from 'availity-reactstrap-validation';

import {
  LocationSearchInput,
  EmptyContainer,
  CustomTable,
} from '../../../../components';

import {
  getOrgContractorsList,
  getOccupationTypes,
  getOccupation,
  createOrgContractor,
  updateOrgContractor,
  deleteOrgContractor,
} from '../../../../store/actions';

import {
  map,
  get,
  groupBy,
  filter,
  uniqBy,
  isEmpty,
} from '../../../../utils/lodash';

import '../organization.scss';
import { getABN } from '../../../../utils';
import { INSTANCE_DEFAULT_COUNTRY_CODE } from '../../../../utils/instanceConstant';

class ContractorForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      values: {
        country: get(
          props,
          'selectedContractor.country',
          INSTANCE_DEFAULT_COUNTRY_CODE
        ),
      },
      isLoading: false,
      results: [],
      searchValue: '',
      searchId: '',
      searchError: false,
      abnList: [],
      selectedAbn: '',
      companyName: '',
      searchLoading: false,
      reportOpen: false,
      searchValidation: false,
      contractorCategory: 'confirmed',
    };
  }

  componentWillMount() {
    this.resetComponent();
  }

  componentDidMount() {
    const { selectedContractor, isNew } = this.props;
    if (!isNew) {
      this.setState({
        searchValue: selectedContractor.occupation
          ? selectedContractor.occupation.code
          : '',
        searchId: selectedContractor.occupation
          ? selectedContractor.occupation.code
          : '',
        companyName: selectedContractor.companyName
          ? selectedContractor.companyName
          : '',
      });
      this.occupationGroupChange(
        get(selectedContractor, 'occupationMinorGroup.code', null)
      );
    }
  }

  async handleValidSubmit(event, values) {
    try {
      const {
        isNew,
        toggle,
        createOrgContractor,
        updateOrgContractor,
        projectId,
        resetPage,
      } = this.props;

      const { searchId, searchError, companyName } = this.state;

      if (searchError) return;

      values.occupationCode = searchId;
      values.companyName = companyName;
      values.activityId = projectId;

      values.organisationId && delete values.organisationId;
      values.createdBy && delete values.createdBy;

      values.occupationCode = searchId;
      values.companyName = companyName;

      if (isNew) {
        const isSubmitted = await createOrgContractor(values, projectId);

        if (isSubmitted) {
          this.form && this.form.reset();
          toggle();
          resetPage();
        }
      } else {
        const { selectedContractor } = this.props;
        const isSubmitted = await updateOrgContractor(
          selectedContractor.id,
          values,
          projectId
        );

        if (isSubmitted) {
          toggle();
          this.form && this.form.reset();
          resetPage();
        }
      }
    } catch (error) {
      console.error('ContractorForm ~ handleValidSubmit ~ error: ', error);
    }
  }

  handleSubmit() {
    this.setState({ searchError: this.state.searchId ? false : true });
  }

  async setLocations(data) {
    const addressNo = get(data, 'streetNumber');
    const addressLine = get(data, 'streetAddress');
    let values = {
      streetAddress:
        addressNo && addressLine
          ? addressNo.concat(', ', addressLine)
          : addressNo || addressLine,
      streetAddress2: '',
      suburb: data.suburb ? data.suburb : '',
      state: data.state ? data.state : '',
      postcode: data.postcode ? data.postcode : '',
      country: data.country ? data.country : '',
    };
    this.setState({ values });
  }

  renderServiceOption(types) {
    return map(types, (item, i) => (
      <option key={i} value={item.id}>
        {item.name}
      </option>
    ));
  }

  renderServiceGroup() {
    const { occupationTypes } = this.props.extra;
    const occupationTypesList = groupBy(occupationTypes, (i) => {
      return i.parentName;
    });

    return map(occupationTypesList, (item, i) => (
      <optgroup key={i} label={i}>
        {this.renderServiceOption(item)}
      </optgroup>
    ));
  }

  renderCountries() {
    const currentLanguage = this.props.i18n.language || 'en';
    const countryObj = countries.getNames(currentLanguage, { select: 'alias' });

    return Object.entries(countryObj).map(([code, name]) => (
      <option key={code} value={code} name={name}>
        {name}
      </option>
    ));
  }

  resetComponent() {
    this.setState({
      isLoading: false,
      results: [],
      searchValue: '',
      searchId: '',
    });
  }

  handleResultSelect = (e, result) => {
    this.setState({
      searchId: result.value,
      searchValue: result.value,
      searchError: false,
    });
  };

  occupationGroupChange(value, isNew) {
    let { occupations } = this.props.extra;
    occupations = filter(occupations, (o) => {
      // eslint-disable-next-line
      return value == String(o.code).slice(0, 2);
    });
    occupations = uniqBy(occupations, (o) => {
      return o.title;
    });

    occupations = map(occupations, (item, i) => ({
      key: item.code,
      value: item.code,
      text: item.title,
    }));

    this.setState({
      occupationGroupCode: value,
      occupations: occupations,
      results: occupations,
    });

    if (isNew) {
      this.setState({
        searchValue: '',
        searchId: '',
      });
    }
  }

  handleResult = (e, { result }) => {
    this.setState({
      selectedAbn: result.Abn,
      companyName: result.Name,
      reportOpen: false,
    });
  };

  handleOnChange = async (e, { value }) => {
    try {
      await this.setState({ companyName: value });
    } catch (error) {}
  };

  handleSearchChange = async () => {
    try {
      const { companyName } = this.state;
      await this.setState({ searchLoading: true });
      let abnList = await getABN(companyName);
      await this.setState({
        abnList: abnList.Names,
        reportOpen: true,
        searchLoading: false,
      });
    } catch (error) {
      await this.setState({ searchLoading: false });
    }
  };

  closeResults = () => {
    this.setState({ reportOpen: false });
  };

  handleContractorCategory = (category) => {
    this.setState({ contractorCategory: category });
  };

  render() {
    const {
      t,
      selectedContractor,
      isNew,
      viewOnly,
      organization: { loading = false },
    } = this.props;

    const {
      values,
      isLoading,
      searchValue,
      results,
      occupationGroupCode,
      searchError,
      abnList,
      companyName,
      selectedAbn,
      searchLoading,
      reportOpen,
      contractorCategory,
    } = this.state;

    return (
      <AvForm
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        onSubmit={(event, values) => this.handleSubmit(event, values)}
        model={selectedContractor}
        className="venue-form"
      >
        {isNew && (
          <div className="contact-flex">
            <div className="col-8 inputs-left-align-flex">
              <Grid>
                <Grid.Row>
                  <div className="contact-category-container">
                    <label className="contact-category-header">
                      {t('formulary.status')}
                    </label>
                    <div>
                      <AvRadioGroup
                        name="contractorCategory"
                        className="contact-category-checkBox"
                        value={contractorCategory}
                        validate={{
                          required: {
                            value: true,
                            errorMessage: t(
                              'formulary.validation.contractor_category_required'
                            ),
                          },
                        }}
                      >
                        <Grid.Column
                          className="contact-category-row"
                          mobile={16}
                          tablet={8}
                          computer={5}
                        >
                          <div className="contact-category-radio">
                            <AvRadio
                              name="category"
                              type="radio"
                              label={t('contractor_status.confirmed')}
                              value="confirmed"
                              onChange={() =>
                                this.handleContractorCategory('confirmed')
                              }
                            />
                          </div>
                        </Grid.Column>
                        <Grid.Column
                          className="contact-category-row"
                          mobile={16}
                          tablet={8}
                          computer={5}
                        >
                          <div className="contact-category-radio">
                            <AvRadio
                              name="category"
                              type="radio"
                              label={t('contractor_status.projected')}
                              value="projected"
                              onChange={() =>
                                this.handleContractorCategory('projected')
                              }
                            />
                          </div>
                        </Grid.Column>
                      </AvRadioGroup>
                    </div>
                  </div>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        )}
        <div className="contact-flex">
          <div className="col inputs-left-align-flex">
            {viewOnly ? (
              <AvField
                label={t('formulary.company_business_name')}
                className="venue-inputs-new"
                placeholder={t(
                  'formulary.placeholder.enter_company_business_name'
                )}
                name="acn"
                type="text"
                value={companyName}
                disabled={viewOnly}
              ></AvField>
            ) : (
              <>
                <label>
                  {t('formulary.company_business_name')}
                  {contractorCategory === 'confirmed' && (
                    <span className="required-asterisk">*</span>
                  )}
                </label>
                <div className="search-fl">
                  <Search
                    name="companyName"
                    onResultSelect={this.handleResult}
                    onSearchChange={this.handleOnChange}
                    open={reportOpen}
                    onBlur={this.closeResults}
                    icon="none"
                    results={abnList}
                    value={companyName}
                    placeholder={t('actions.search')}
                    resultRenderer={({ Abn, Name, Postcode, State }) => (
                      <div>
                        <label>
                          {Name.charAt(0).toUpperCase() + Name.slice(1)}
                        </label>
                        <div className="contact-search-result">
                          <label>
                            <label className="sub-info">
                              {t('formulary.state')}:{'  '}
                            </label>
                            <label className="info"> {State}</label>
                          </label>
                          <label className="leftInfo">
                            <label className="sub-info">
                              {t('formulary.postcode')}:{' '}
                            </label>
                            <label className="info"> {Postcode}</label>
                          </label>
                          <label className="leftInfo">
                            <label className="sub-info">
                              {t('formulary.abn')}:{' '}
                            </label>
                            <label className="info"> {Abn}</label>
                          </label>
                        </div>
                      </div>
                    )}
                    className="contactSearch search-custom-height"
                  />

                  <div className="icon-button-partner">
                    <Button.Group>
                      <Button
                        type="button"
                        labelPosition="left"
                        icon="search"
                        content={t('actions.search')}
                        className="search-button-contact"
                        onClick={this.handleSearchChange}
                        loading={searchLoading}
                        disabled={searchLoading}
                      ></Button>
                    </Button.Group>
                  </div>
                </div>
                {this.state.searchValidation &&
                contractorCategory === 'confirmed' ? (
                  <div className="invalid-dropdown-input">
                    {t('formulary.validation.company_business_name_required')}
                  </div>
                ) : null}
              </>
            )}
          </div>

          <div className="col inputs-right-align-flex">
            <AvField
              label={
                <div>
                  {t('formulary.abn_acn')}{' '}
                  {contractorCategory === 'confirmed' && (
                    <span className="required-asterisk">*</span>
                  )}
                </div>
              }
              className="venue-inputs-new"
              placeholder={t('formulary.placeholder.enter_abn_acn')}
              name="acn"
              type="text"
              value={selectedAbn}
              // onChange={v => this.occupationGroupChange(v.target.value, true)}
              validate={{
                required: {
                  value: contractorCategory === 'confirmed' ? true : false,
                  errorMessage: t('formulary.validation.abn_acn_required'),
                },
              }}
              disabled={viewOnly}
            ></AvField>
          </div>
        </div>

        <div className="contact-flex">
          <div className="col inputs-left-align-flex">
            <AvField
              label={
                <>
                  {t('formulary.anzsco_contractor_service_group')}{' '}
                  <span className="required-asterisk">*</span>
                </>
              }
              className="venue-inputs-new"
              name="occupationMinorGroupCode"
              type="select"
              onChange={(v) => this.occupationGroupChange(v.target.value, true)}
              validate={{
                required: {
                  value: true,
                  errorMessage: t(
                    'formulary.validation.contractor_service_group_required'
                  ),
                },
              }}
              disabled={viewOnly}
            >
              <option value="" defaultValue disabled>
                {t('formulary.placeholder.select_contractor_service_group')}
              </option>
              {this.renderServiceGroup()}
            </AvField>
          </div>

          <div className="col inputs-right-align-flex">
            {!viewOnly ? (
              <div className="contact-drop-search">
                <label>
                  {t('formulary.anzsco_occupation_service_type')}{' '}
                  {<span className="required-asterisk">*</span>}
                </label>
                <Dropdown
                  loading={isLoading}
                  placeholder={t('actions.search')}
                  fluid
                  search
                  selection
                  className={
                    searchError
                      ? 'venue-inputs-new error-contractor'
                      : 'venue-inputs-new'
                  }
                  onChange={(event, data) =>
                    this.handleResultSelect(event, data)
                  }
                  options={results}
                  value={searchValue}
                  disabled={
                    viewOnly
                      ? true
                      : isNew
                        ? occupationGroupCode
                          ? false
                          : true
                        : false
                  }
                />
                {searchError ? (
                  <div className="custom-error-label">
                    {t('formulary.validation.occupation_service_type_required')}
                  </div>
                ) : null}
              </div>
            ) : (
              <AvField
                label={t('formulary.occupation_service_type')}
                className="venue-inputs-new"
                name="occupation"
                type="text"
                value={searchValue}
                disabled={true}
              />
            )}
          </div>
        </div>

        <div className="contact-flex">
          <div className="col inputs-left-align-flex">
            <AvField
              label={
                <>
                  {t('formulary.first_name')}{' '}
                  {contractorCategory === 'confirmed' && (
                    <span className="required-asterisk">*</span>
                  )}
                </>
              }
              className="venue-inputs-new"
              placeholder={t('formulary.placeholder.enter_first_name')}
              name="firstName"
              type="text"
              validate={{
                required: {
                  value: contractorCategory === 'confirmed' ? true : false,
                  errorMessage: t('formulary.validation.first_name_required'),
                },
              }}
              disabled={viewOnly}
            />
          </div>
          <div className="col inputs-right-align-flex">
            <AvField
              label={
                <>
                  {t('formulary.surname')}{' '}
                  {contractorCategory === 'confirmed' && (
                    <span className="required-asterisk">*</span>
                  )}
                </>
              }
              className="venue-inputs-new"
              placeholder={t('formulary.placeholder.enter_surname')}
              name="secondName"
              type="text"
              validate={{
                required: {
                  value: contractorCategory === 'confirmed' ? true : false,
                  errorMessage: t('formulary.validation.surname_required'),
                },
              }}
              disabled={viewOnly}
            />
          </div>
        </div>

        <div className="contact-flex">
          <div className="col inputs-left-align-flex">
            <AvField
              label={
                <>
                  {t('formulary.phone')}{' '}
                  {contractorCategory === 'confirmed' && (
                    <span className="required-asterisk">*</span>
                  )}
                </>
              }
              className="venue-inputs-new"
              placeholder={t('formulary.placeholder.enter_phone_number')}
              name="phone"
              type="number"
              validate={{
                minLength: {
                  value: 10,
                  errorMessage: t('formulary.validation.minimum_10_digits'),
                },
                required: {
                  value: contractorCategory === 'confirmed' ? true : false,
                  errorMessage: t('formulary.validation.phone_required'),
                },
              }}
              disabled={viewOnly}
            />
          </div>
          <div className="col inputs-right-align-flex">
            <AvField
              label={
                <>
                  {t('formulary.email')}{' '}
                  {contractorCategory === 'confirmed' && (
                    <span className="required-asterisk">*</span>
                  )}
                </>
              }
              className="venue-inputs-new"
              placeholder={t('formulary.placeholder.enter_email')}
              name="email"
              type="email"
              errorMessage={t('formulary.validation.valid_email')}
              validate={{
                required: {
                  value: contractorCategory === 'confirmed' ? true : false,
                  errorMessage: t('formulary.validation.email_required'),
                },
              }}
              disabled={viewOnly}
            />
          </div>
        </div>
        <AvField
          label={t('formulary.website')}
          className="venue-inputs-new"
          placeholder={t('formulary.placeholder.enter_website')}
          name="website"
          type="text"
          disabled={viewOnly}
        />

        <div className="col-6 inputs-left-align-flex">
          <AvField
            label={
              <>
                {t('formulary.country')}
                <span className="required-asterisk">*</span>
              </>
            }
            className="venue-inputs-new"
            name="country"
            type="select"
            onChange={(e) =>
              this.setState({ values: { ...values, country: e.target.value } })
            }
            validate={{
              required: {
                value: true,
                errorMessage: t('formulary.validation.country_required'),
              },
            }}
            disabled={viewOnly}
            value={values['country']}
          >
            <option value="" defaultValue disabled>
              {t('formulary.placeholder.select_country')}
            </option>
            {this.renderCountries()}
          </AvField>
        </div>

        {!viewOnly ? (
          <LocationSearchInput
            customClass="org-inputs-location-search-contact"
            getLocation={(data) => this.setLocations(data)}
            value={companyName}
            label={t('formulary.placeholder.search_address_with_google')}
            country={values['country']}
          />
        ) : null}

        <div className="contact-flex">
          <div className="col inputs-left-align-flex">
            <AvField
              label={
                <>
                  {t('formulary.address_line_1')}{' '}
                  {contractorCategory === 'confirmed' && (
                    <span className="required-asterisk">*</span>
                  )}
                </>
              }
              className="venue-inputs-new"
              name="streetAddress"
              type="text"
              validate={{
                required: {
                  value: contractorCategory === 'confirmed' ? true : false,
                  errorMessage: t(
                    'formulary.validation.street_address_required'
                  ),
                },
              }}
              value={values['streetAddress']}
              disabled={viewOnly}
            />
          </div>
          <div className="col inputs-right-align-flex">
            <AvField
              label={t('formulary.address_line_2')}
              className="venue-inputs-new"
              name="streetAddress2"
              type="text"
              value={values['streetAddress2']}
              disabled={viewOnly}
            />
          </div>
        </div>

        <div className="contact-flex">
          <div className="col inputs-left-align-flex">
            <AvField
              label={
                <>
                  {t('formulary.suburb')}{' '}
                  {contractorCategory === 'confirmed' && (
                    <span className="required-asterisk">*</span>
                  )}
                </>
              }
              className="venue-inputs-new"
              name="suburb"
              type="text"
              validate={{
                required: {
                  value: contractorCategory === 'confirmed' ? true : false,
                  errorMessage: t('formulary.validation.suburb_required'),
                },
              }}
              value={values['suburb']}
              disabled={viewOnly}
            />
          </div>
          <div className="col">
            <AvField
              label={
                <>
                  {t('formulary.state_province')}{' '}
                  {contractorCategory === 'confirmed' && (
                    <span className="required-asterisk">*</span>
                  )}
                </>
              }
              className="venue-inputs-new"
              name="state"
              type="text"
              validate={{
                required: {
                  value: contractorCategory === 'confirmed' ? true : false,
                  errorMessage: t('formulary.validation.state_required'),
                },
              }}
              value={values['state']}
              disabled={viewOnly}
            />
          </div>
          <div className="col inputs-right-align-flex">
            <AvField
              label={
                <>
                  {t('formulary.postcode')}{' '}
                  {contractorCategory === 'confirmed' && (
                    <span className="required-asterisk">*</span>
                  )}
                </>
              }
              className="venue-inputs-new"
              name="postCode"
              type="text"
              validate={{
                required: {
                  value: contractorCategory === 'confirmed' ? true : false,
                  errorMessage: t('formulary.validation.postcode_required'),
                },
              }}
              value={values['postcode']}
              disabled={viewOnly}
            />
          </div>
        </div>

        {!viewOnly ? (
          <div className="contact-modal-buttons">
            <Button
              disabled={loading}
              loading={loading}
              content={
                isNew
                  ? t('specific_actions.add_contractor')
                  : t('actions.save_changes')
              }
              size="small"
              type="submit"
              className="Primary-Button"
            />
          </div>
        ) : null}
      </AvForm>
    );
  }
}

class ContractorDelete extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  deleteOrgContractorHandle() {
    const { deleteOrgContractor, selectedContractor, resetPage } = this.props;
    deleteOrgContractor(selectedContractor.id);
    if (resetPage) resetPage();
    this.toggle();
  }

  render() {
    const { modal } = this.state;
    const { t, selectedContractor } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        onClose={() => this.toggle()}
        size="mini"
        trigger={
          <label className="org-users-actions-error first-down">
            {t('actions.remove')}
          </label>
        }
        className="delete-contractor"
      >
        <Modal.Header className="modal-header-font">
          {t('organisation.contacts.delete_contractor_with_name', {
            name: selectedContractor.name,
          })}
        </Modal.Header>
        <Modal.Content>
          <p>{t('organisation.contacts.confirm_delete_contractor')}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.toggle()} className="Secondary-Button">
            {t('actions.no')}
          </Button>
          <Button
            onClick={() => this.deleteOrgContractorHandle()}
            className="Primary-Button"
            content={t('actions.yes')}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export class ContractorUpdate extends PureComponent {
  //-------------------------this component is used in Activity Plan UI--------------
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t, selectedContractor } = this.props;
    return (
      <div className="add-user">
        <Modal
          trigger={
            <label className="org-users-actions-warn first-down default-color ">
              {t('actions.edit')}
            </label>
          }
          size="small"
          open={modal}
          onOpen={() => this.toggle()}
          closeIcon={
            <div
              className="new-activity-modal-close-icon"
              onClick={() => this.toggle()}
            >
              &times;
            </div>
          }
          className="edit-new-contractor"
        >
          <Modal.Header className="modal-header-font">
            {t('organisation.contacts.update_contractor_header')}{' '}
            {!isEmpty(selectedContractor.name.trim()) &&
              `- ${selectedContractor.name}`}
          </Modal.Header>
          <Modal.Content>
            <ContractorForm
              toggle={() => this.toggle()}
              isNew={false}
              {...this.props}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class ContractorView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t, selectedContractor } = this.props;

    return (
      <div className="add-user">
        <Modal
          trigger={
            <label className="org-users-actions-warn">
              {t('actions.view')}
            </label>
          }
          size="small"
          open={modal}
          onOpen={() => this.toggle()}
          closeIcon={
            <div
              className="new-activity-modal-close-icon"
              onClick={() => this.toggle()}
            >
              &times;
            </div>
          }
          className="view-contractor"
        >
          <Modal.Header className="modal-header-font">
            {t('organisation.contacts.view_contractor_with_name', {
              name: selectedContractor.name,
            })}
          </Modal.Header>
          <Modal.Content>
            <ContractorForm
              toggle={() => this.toggle()}
              isNew={false}
              viewOnly={true}
              {...this.props}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class ContractorCreateComponent extends PureComponent {
  //-------------------------this component is used in Activity Plan UI--------------
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t, projectId, disabled } = this.props;

    return (
      <div className="add-contact-container">
        <Modal
          trigger={
            <Button
              disabled={disabled}
              className={
                projectId ? 'customColor-wrapper-contact' : 'Primary-Button'
              }
            >
              <Icon name="plus" />
              {t('organisation.contacts.add_new_contractor')}
            </Button>
          }
          size="small"
          open={modal}
          onOpen={() => this.toggle()}
          closeIcon={
            <div
              className="new-activity-modal-close-icon"
              onClick={() => this.toggle()}
            >
              &times;
            </div>
          }
          className="add-new-contractor"
        >
          <Modal.Header className="modal-header-font">
            {t('organisation.contacts.add_new_contractor')}
          </Modal.Header>
          <Modal.Content>
            <ContractorForm
              toggle={() => this.toggle()}
              isNew={true}
              {...this.props}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class OrganizationContractors extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
  }

  resetPage() {
    this.setState({
      currentPage: 1,
    });
  }

  columns() {
    return [
      {
        title: '',
        render: (data) => {
          return (
            <div className="org-users-container">
              <label className="org-users-mainText">
                {data.companyName || '-'}
              </label>
              <label className="org-users-text">
                {data.occupationMinorGroup
                  ? data.occupationMinorGroup.name || '-'
                  : '-'}
              </label>
            </div>
          );
        },
      },
      {
        title: '',
        render: (data) => {
          return <label>{data.email || '-'}</label>;
        },
      },
      {
        title: '',
        render: (data) => {
          return <label>{data.phone || '-'}</label>;
        },
      },
      {
        title: '',
        render: (data) => {
          return (
            <div className="org-users-actions">
              <ContractorView selectedContractor={data} {...this.props} />
              <ContractorUpdate
                selectedContractor={data}
                resetPage={() => this.resetPage()}
                {...this.props}
              />
              <ContractorDelete
                selectedContractor={data}
                resetPage={() => this.resetPage()}
                {...this.props}
              />
            </div>
          );
        },
      },
    ];
  }

  async componentDidMount() {
    const { currentPage } = this.state;
    const { auth, getOrgContractorsList, getOccupationTypes, getOccupation } =
      this.props;
    if (!isEmpty(auth.user) && auth.user.organisation) {
      await getOrgContractorsList(currentPage);
    }
    getOccupationTypes();
    getOccupation();
  }

  pageChange(page) {
    const { auth, getOrgContractorsList } = this.props;
    this.setState(
      {
        currentPage: page,
      },
      () => {
        if (!isEmpty(auth.user) && auth.user.organisation) {
          getOrgContractorsList(page);
        }
      }
    );
  }

  render() {
    const { t } = this.props;
    const { orgContractors, loading } = this.props.organization;
    const { currentPage } = this.state;

    return (
      <Segment className="content-segment org-users" loading={loading}>
        <Grid>
          <Grid.Row className="add-contact-org-row">
            <Grid.Column
              mobile={16}
              tablet={16}
              computer={16}
              textAlign="right"
            >
              <ContractorCreate
                {...this.props}
                resetPage={() => this.resetPage()}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        {orgContractors.docs && orgContractors.docs.length ? (
          <div className="org-table-container">
            <CustomTable
              columns={this.columns()}
              data={orgContractors.docs}
              customClass="org-users-table"
              pagination
              handlePaginationChange={(page) => this.pageChange(page)}
              page={currentPage}
              noOfPages={orgContractors.pages}
              keyExtractor={(item, index) => item.id}
            />
          </div>
        ) : (
          <EmptyContainer
            msg={t('organisation.contacts.no_contractors_added')}
          />
        )}
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
    organization: state.organization,
    extra: state.extra,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getOrgContractorsList,
      getOccupationTypes,
      getOccupation,
      createOrgContractor,
      updateOrgContractor,
      deleteOrgContractor,
    },
    dispatch
  );
};

OrganizationContractors = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(OrganizationContractors));

export const ContractorCreate = withTranslation()(ContractorCreateComponent);
export { OrganizationContractors };
